import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: null,
  slug: null,
  uuid: null,
  description: null,
  inviteCode: null,
  isActive: null,
  links: null,
  locations: null,
  userList: null,
  isLoading: false,
};

// Data stored for providers viewed on isAdmin mode
const otherProvider = createSlice({
  name: 'otherProvider',
  initialState,
  reducers: {
    otherProviderRequest(state) {
      state.isLoading = true;
    },
    otherProviderSuccess(state, { payload }) {
      return {
        ...payload.data,
        isLoading: false,
      };
    },
    otherProviderFailure(state) {
      state.isLoading = false;
    },
    clearOtherProviderData() {
      return initialState;
    },
  },
});

const { actions, reducer } = otherProvider;

export const {
  otherProviderRequest,
  otherProviderSuccess,
  otherProviderFailure,
  clearOtherProviderData,
} = actions;

export default reducer;
